import supabase from './supabase';
import { recordCountry } from './country-tracking';

// Avoid overlapping requests within this tab (including repeated React effects).
// This lock does not coordinate separate tabs.
let pending = false;
export async function recordVisit() {
  if (pending) return;
  pending = true;
  try {
    const now = Date.now();
// Random browser identifier, not an account/person ID. Clearing storage or using
    // another device produces a new visitor; unavailable storage skips tracking.
    let visitor = localStorage.getItem('prayer-visitor');
    if (!visitor) {
      visitor = crypto.randomUUID();
      localStorage.setItem('prayer-visitor', visitor);
    }
// Share the session across reloads and tabs using localStorage. Simultaneous
    // first visits in separate tabs can still race, so these are approximate counts.
    let session;
    try { session = JSON.parse(localStorage.getItem('prayer-visit')); } catch {}
    if (!session || now - session.lastActive > 30 * 60 * 1000) {
      session = { id: crypto.randomUUID(), lastActive: now, recorded: false };
    }
    session.lastActive = now;
    localStorage.setItem('prayer-visit', JSON.stringify(session));
    // Keep the same session ID on failure. The database primary key makes retries
    // idempotent, even if a successful response was lost in transit.
    if (!session.recorded) {
      const { error } = await supabase.rpc('record_app_visit_details', { visitor_key: visitor, session_key: session.id, ...visitContext() });
      if (!error) {
        void recordCountry(session.id, visitor);
        session.recorded = true;
        localStorage.setItem('prayer-visit', JSON.stringify(session));
      }
    }
  } catch {
    // Skip tracking when storage is unavailable. The app remains usable.
  } finally { pending = false; }
}

// Keep source labels coarse: never collect full referrer URLs or query strings.
export function visitContext() {
  const ua = navigator.userAgent;
  const device_label = /iPad|Tablet/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'Tablet' : /Mobi|Android/i.test(ua) ? 'Phone' : 'Desktop';
  let source_label = 'Direct / unknown';
  const tag = new URLSearchParams(window.location.search).get('utm_source');
  if (tag && /^[a-zA-Z0-9_-]{1,40}$/.test(tag)) source_label = 'Campaign: ' + tag;
  else if (document.referrer) {
    try { const ref = new URL(document.referrer); if(ref.host !== window.location.host) source_label = ref.hostname; } catch {}
  }
  return { device_label, source_label };
}

export async function recordEngagement(action) {
  if (window.location.pathname !== '/') return;
  try {
    await recordVisit();
    const session = JSON.parse(localStorage.getItem('prayer-visit'));
    if (!session?.recorded) return;
    await supabase.rpc('record_app_engagement', { event_key: crypto.randomUUID(), session_key: session.id, event_action: action });
  } catch { /* Stats must never interrupt a successful user action. */ }
}
